import { ReactComponent as AddSvg } from './svg/add.svg'

const AddIcon = ({ fill = '#FFFFFF', ...props }) => <AddSvg fill={fill} {...props} />

export default AddIcon
